{
  "account": {
    "title": "Contul meu",
    "list": {
      "title": "Conturi",
      "description": "Listă de facturi pentru conturi asociate"
    },
    "form": {
      "name": {
        "title": "Nume",
        "description": "Numele contului tău"
      },
      "password": {
        "title": "Parolă",
        "description": "Setează o parolă nouă pentru cont; lasă gol pentru a păstra parola actuală"
      },
      "emailPreferences": {
        "title": "Preferințe e-mail",
        "description": "Selectează tipurile de notificări prin e-mail"
      }
    },
    "billing": "Detalii de facturare",
    "subscriptions": "Abonamente",
    "manageSubscription": "Gestionează abonamentul",
    "popup": {
      "cancel": "Sigur dorești să îți anulezi abonamentul?<br/>Site-ul tău va continua să fie tradus până la sfârșitul perioadei de abonament actuale. După aceea, traducerea va fi dezactivată.<br/>Te rugăm să reții că nu vei fi eligibil pentru o rambursare pentru perioada neutilizată.",
      "downgrade": "Sigur dorești să treci la un plan inferior? Modificarea va intra în vigoare imediat.<br/>Te rugăm să reții că nu vei fi eligibil pentru o rambursare pentru timpul rămas din ciclul de facturare curent.<br/>Noul preț al planului va fi aplicat începând cu următorul ciclu de facturare.",
      "default": "Sigur dorești să îți modifici planul?",
      "resume": "Sigur vrei să-ți reiei abonamentul?"
    }
  },
  "ai_translation": {
    "header": "Traducere AI",
    "plan": {
      "header": "Prețuri Traducere AI",
      "used": "Ai utilizat {words_used} / {words_allowed} cuvinte traduse în creditele tale AI.",
      "remaining": "Credite AI disponibile:",
      "words": "cuvinte",
      "add_more_credits": "Adaugă mai multe credite AI",
      "details": {
        "idiomatic_expressions": "Expresii idiomatice și tehnice",
        "background_translation": "Traduceri în fundal",
        "best_website": "Site-uri care necesită calitate perfectă de traducere",
        "page_context": "Contextul paginii și al site-ului pentru traducere",
        "perfect_quality": "Calitate perfectă, preț avantajos",
        "no_recurring": "Fără plată recurentă, cotă pre-plătită",
        "save_40": "Economisește 40% față de planul de 20 $",
        "save_50": "Economisește 50% față de planul de 20 $"
      },
      "quota": "{estimated_words} cuvinte ~ {estimated_pages} pagini"
    },
    "settings": {
      "banner": {
        "title": "Traducere AI Linguise",
        "intro": "Linguise este încântat să prezinte Traducerea AI Linguise, o nouă funcționalitate premium care utilizează modele AI LLM (cele mai recente modele Llama, optimizate pentru traduceri). Concepută pentru site-uri care necesită acuratețe impecabilă, ia în considerare atât contextul paginii, cât și al întregului site, pentru rezultate de neegalat. Oferă clienților tăi apogeul calității traducerii, asigurându-te că mesajul lor rezonează perfect în fiecare limbă.",
        "button": "Upgradează acum"
      },
      "alert": {
        "description": "Această funcționalitate nu este inclusă în planul tău actual și necesită o achiziție separată.\nActivează acest supliment pentru a debloca toate opțiunile enumerate mai jos."
      },
      "languages": {
        "title": "Aplică traducerea AI la limbi",
        "description": "Selectează limba specifică la care dorești să se aplice traducerea AI"
      },
      "button": {
        "save": "Salvează setările"
      },
      "form": {
        "advanced": {
          "title": "Instrucțiuni AI avansate",
          "description": "Instrucțiuni AI avansate"
        },
        "enable_mode": {
          "title": "ACTIVEAZĂ TRADUCEREA AI",
          "description": "Alege modul în care dorești să fie activată traducerea AI.\nDoar reguli va aplica regulile de mai jos.\nEditor live doar va permite activarea traducerii pagină cu pagină din vizualizarea editorului live.\nReguli și editor live va folosi ambele funcționalități.",
          "disabled": "Dezactivat",
          "rules": "Doar reguli",
          "live_editor": "Doar editor live",
          "all": "Reguli și editor live"
        },
        "rule_application": {
          "description": "Aplică Traducerea AI pe conținut static sau dinamic sau pe ambele",
          "title": "Aplică la conținut",
          "all": "Tot conținutul",
          "static": "Conținut static",
          "dynamic": "Conținut dinamic"
        },
        "website_topic": {
          "title": "Subiectul site-ului",
          "placeholder": "Restaurant sushi...",
          "description": "Definește subiectul site-ului tău pentru o calitate mai bună a traducerii (ex. Juridic, restaurant sushi, magazin online de piese de bicicletă…)\nTe rugăm să introduci subiectul site-ului în engleză."
        },
        "apply_to_urls": {
          "title": "Aplică la URL-uri",
          "description": "Selectează URL-urile specifice la care dorești să se aplice traducerea AI",
          "all_urls": "Toate URL-urile",
          "selected_urls": "URL-uri selectate",
          "label": "URL la care să se aplice",
          "placeholder": "URL la care să se aplice",
          "wildcard": "Caracter generic",
          "regex": "Expresie regulată",
          "add": "Adaugă nou",
          "expression": "Tipul expresiei"
        },
        "apply_languages": {
          "title": "Aplică la limbi",
          "description": "Selectează limba specifică la care dorești să se aplice traducerea AI",
          "all_languages": "Toate limbile",
          "selected_languages": "Limbi selectate",
          "placeholder": "Selectează limbile...",
          "feedback": "Trebuie să alegi o limbă"
        },
        "formality": {
          "title": "Formalitate",
          "description": "Specifică gradul de formalitate în traduceri, posibil important pentru audiențe și contexte.\n„Neutru” va încerca să păstreze formalitatea conținutului original.\n„Formal” este pentru conținut profesional, de afaceri sau juridic (ex. folosind pronume formale precum „usted” în spaniolă).\n„Informal” este pentru conținut casual, conversațional (ex. folosind „tú” în spaniolă).",
          "neutral": "Neutru",
          "formal": "Formal",
          "informal": "Informal"
        },
        "sentence_structure": {
          "classic": "Clasic",
          "short": "Propoziții scurte și incisive",
          "detailed": "Propoziții detaliate și explicative",
          "title": "Structura propozițiilor",
          "description": "Definește preferința pentru stilul de scriere."
        },
        "content_purpose": {
          "marketing": "Marketing/promovare (ton convingător, atractiv)",
          "technical": "Tehnic/instrucțional (clar, precis, orientat spre acțiune)",
          "support": "Asistență pentru clienți (empatic, util, liniștitor)",
          "legal": "Juridic/conformitate (precis, formal, neechivoc)",
          "educational": "Educațional (clar, structurat, accesibil)",
          "other": "Altul (în engleză)",
          "title": "Scopul conținutului",
          "description": "Definește scopul funcțional al conținutului care urmează să fie tradus.",
          "other_placeholder": "Descrie scopul..."
        },
        "target_audience": {
          "title": "Publicul țintă",
          "description": "Specificația publicului țintă al conținutului tradus (în engleză).",
          "placeholder": "de exemplu, părinți vorbitori de spaniolă, responsabili de confidențialitate ai UE"
        },
        "override_default_translations": {
          "title": "Suprascrie traducerea prestabilită",
          "description": "Dacă este setat la DA, această opțiune va forța conținutul să fie tradus cu AI (Linguise AI), chiar dacă a fost deja tradus de traducerea Cloud AI (modelul implicit de traducere)."
        },
        "force_replace_before": {
          "title": "Forțează retraducerea cu AI",
          "description": "Tradu din nou cu AI orice conținut a cărui traducere AI a fost creată înainte de data selectată — de exemplu, conținut tradus cu un model mai vechi. Retraducerea are loc la următoarea vizită a paginilor vizate, conform regulilor, și consumă creditele AI.",
          "before_date": "Înainte de o dată"
        },
        "model": {
          "current": "Actual",
          "title": "Model",
          "description": "Selectați modelul de traducere LLM pe care doriți să îl utilizați",
          "load_error": "Nu se pot încărca modelele disponibile. Vă rugăm să încercați din nou mai târziu.",
          "thinking_warning": "Acest model utilizează un nivel ridicat de raționament (\"gândire\") și va consuma semnificativ mai multe token-uri per traducere."
        },
        "override_manual_and_selected": {
          "no_default": "Nu (implicit)",
          "title": "Suprascrie traducerile manuale și selectate",
          "description": "Implicit, o traducere pe care ai editat-o manual rămâne mereu pe site-ul tău, chiar și după generarea unei traduceri îmbunătățite cu AI. Setează pe DA pentru a afișa în schimb traducerea îmbunătățită cu AI. Traducerile tale manuale sunt păstrate și poți reveni oricând. Acest lucru se aplică și atunci când retraduci paginile pentru a obține traduceri noi; cea mai recentă traducere va fi folosită automat."
        }
      },
      "message": {
        "save_success": "Din conținutul deja tradus, numărul de pagini care vor fi îmbunătățite cu traducere AI este aproximativ {{ai_affected_urls}}.",
        "save_success_only": "Setările au fost salvate cu succes."
      }
    },
    "pricing": {
      "plan": {
        "title": "Comandă cotă de traducere AI",
        "buy_button": "CUMPĂRĂ PACHET DE TRADUCERE AI"
      },
      "modal": {
        "title": "Confirmă schimbarea planului",
        "description": "Sigur dorești să îți modifici planul de Traducere AI?",
        "button_cancel": "Anulează",
        "button_confirm": "Confirmă",
        "loading": "Vă rugăm să așteptați...",
        "amount": "Sumă",
        "credit": "Credit",
        "total_due": "Total de plată"
      },
      "comparison": {
        "title": "Traducere AI Google Cloud\nvs traducere AI Linguise",
        "list": {
          "0": {
            "google": "Traduceri rapide și fiabile",
            "linguise": "Tratează expresiile idiomatice și tehnice"
          },
          "1": {
            "google": "Traduceri instantanee ale tuturor paginilor site-ului",
            "linguise": "Generarea traducerilor în fundal"
          },
          "2": {
            "google": "Calitate superioară, preț mic",
            "linguise": "Calitate perfectă, preț accesibil"
          },
          "3": {
            "google": "Cel mai potrivit pentru site-uri mari sau buget redus",
            "linguise": "Cel mai bun pentru site-urile care necesită calitate perfectă a traducerii"
          },
          "4": {
            "google": "Context de pagină pentru traducere",
            "linguise": "Context de pagină și site pentru traducere"
          }
        }
      },
      "botom_banner": {
        "title": "Experimentați o precizie de traducere fără egal cu",
        "sub_title": "Noul Linguise AI Translation",
        "description": "Linguise își îmbunătățește serviciile de traducere automată prin introducerea Linguise AI Translation, o opțiune nouă și puternică care utilizează cea mai avansată tehnologie AI LLM (cele mai recente modele Llama optimizate pentru traduceri). Această adăugire oferă dezvoltatorilor de site-uri și agențiilor web un nivel și mai ridicat al calității traducerii, ideal pentru proiectele în care perfecțiunea este esențială. Linguise AI Translation completează actuala traducere Google Cloud AI de înaltă calitate, oferindu-vă o flexibilitate și precizie mai mari."
      }
    },
    "success": {
      "tab_title": "Vă mulțumim pentru achiziționarea planului AI Translation!",
      "title": "Vă mulțumim pentru achiziționarea planului AI Translation!",
      "subtitle": "Planul dumneavoastră AI Translation a fost achiziționat cu succes!",
      "message": "Vă puteți gestiona planul AI Translation în pagina de setări AI Translation.",
      "home": "Gestionează AI Translation"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Nume",
        "description": "Numele contului de facturare"
      },
      "phone": {
        "title": "Telefon",
        "description": "Telefonul contului de facturare"
      },
      "email": {
        "title": "E-mail",
        "description": "E-mailul contului de facturare"
      },
      "address": {
        "title": "Adresă",
        "description": "Adresa contului de facturare",
        "city": "Oraș",
        "country": "Țară",
        "address1": "Adresă 1",
        "address2": "Adresă 2",
        "postal": "Cod poștal",
        "state": "Stat"
      },
      "tax": {
        "title": "Număr fiscal"
      }
    }
  },
  "checkouts": {
    "header": "Finalizare comandă",
    "payment_method": "Selectați metoda de plată",
    "stripe_card": "Card de credit (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Introduceți o adresă de facturare nouă",
      "existing": "Folosiți adresa existentă"
    },
    "pay_stripe": "Confirmați și plătiți",
    "terms": "Prin confirmarea abonamentului, permiteți Linguise să vă perceapă plăți viitoare în conformitate cu termenii noștri. Vă puteți dezabona oricând.",
    "coupon": {
      "title": "Aveți un cupon?",
      "placeholder": "Introduceți codul cuponului aici",
      "apply": "Aplicați",
      "percent": "{{0}}% reducere"
    },
    "add_new": "Adăugați nou",
    "use_existing": "Folosiți metoda de plată existentă",
    "recurring": {
      "month_single": "Facturat lunar",
      "month_many": "Facturat la fiecare {{count}} luni",
      "year_single": "Facturat anual",
      "year_many": "Facturat la fiecare {{count}} ani",
      "day_single": "Facturat zilnic",
      "day_many": "Facturat la fiecare {{count}} zile",
      "week_single": "Facturat săptămânal",
      "week_many": "Facturat la fiecare {{count}} săptămâni"
    },
    "add_new_no_stripe": "Adăugați card nou",
    "summary": {
      "title": "Rezumat",
      "subtotal": "Subtotal",
      "total": "Total"
    }
  },
  "dashboard": {
    "main": {
      "title": "Panou de control"
    },
    "statistics": {
      "main_title": "Statistici ultimele 30 de zile",
      "characters": "Caractere traduse",
      "words": "Cuvinte traduse",
      "bandwidth": "Lățime de bandă de intrare",
      "request": "Cereri",
      "page_views": "Vizualizări de pagini pe limbă (ultimele 30 de zile)",
      "multilingual_views": "Vizualizări de pagini multilingve (ultimele 30 de zile)",
      "most_page_viewed": "Cele 20 cele mai vizualizate pagini (ultimele 30 de zile)",
      "no_data_yet": "Nu există date disponibile încă",
      "th_language": "Limbă",
      "th_page_views": "Vizualizări pagini",
      "real_visitors": "Vizitatori reali",
      "crawler": "Robot de indexare"
    },
    "planHints": {
      "subscribeButton": "Abonați-vă",
      "upgradeButton": "Trecere la plan superior",
      "usedWords": "În prezent ați folosit {words_used} cuvinte",
      "noPlan": "Niciun plan activat pentru acest domeniu. Abonați-vă la un plan și începeți să traduceți site-ul dvs.",
      "noPlanShopify": "Niciun plan activat pentru acest domeniu. Abonați-vă la un plan din panoul Shopify și începeți să traduceți site-ul dvs.",
      "trialUsage": "În prezent folosiți {words_used} cuvinte din cele {words_allowed} cuvinte incluse în planul de probă.",
      "trialEnds": "Prima lună de probă este activă până pe data de {trial_ends}.",
      "subscribeMessage": "Abonați-vă înainte de sfârșit pentru a vă menține site-ul tradus",
      "subscribeMessageShopify": "Abonați-vă din panoul Shopify înainte de sfârșit pentru a vă menține site-ul tradus",
      "trialReachedLimit": "Ați atins numărul maxim de cuvinte traduse pentru perioada de probă.\nAbonați-vă la unul dintre planurile noastre pentru a continua să traduceți site-ul.",
      "paidUsage": "Ați folosit {words_used} / {words_allowed} cuvinte traduse în planul dumneavoastră.",
      "paidReachedLimit": "Ați atins numărul maxim de cuvinte traduse pentru planul actual.\nFaceți upgrade la plan pentru a continua să traduceți conținutul site-ului.",
      "trialOfferedUsage": "În prezent folosiți {words_used} cuvinte din cele {words_allowed} cuvinte incluse în planul de probă.(Incluzând cele {free_words} cuvinte oferite)",
      "paidOfferedUsage": "Ați folosit {words_used} / {words_allowed} cuvinte traduse în planul dumneavoastră.(Incluzând cele {free_words} cuvinte oferite)",
      "noPlanExtra": "Vă rugăm să rețineți că domeniile inactive și datele acestora sunt șterse automat în mod regulat.",
      "planRecommended": "Pe baza volumului dvs. actual de traducere, planul recomandat este:",
      "planMaximumWords": "{{words}} cuvinte",
      "notHaveTranslatedWords": "Nu ați făcut încă nicio traducere"
    },
    "translationSetup": {
      "kicker": "CONFIGURAREA SUBDOMENIULUI",
      "title": "Verifică setările traducerii",
      "description": "Verifică DNS-ul, gazdele traduse, accesul la site-ul original și limitele contului.",
      "starting": "Se verifică...",
      "button": "Verifică setările",
      "viewLatest": "Vezi ultimul rezultat",
      "viewCurrent": "Vezi verificarea curentă",
      "runAgain": "Rulează din nou verificarea",
      "viewDetails": "Vezi detaliile",
      "hideDetails": "Ascunde detaliile",
      "error": "Setările nu pot fi verificate",
      "allPassed": "Toate verificările au trecut",
      "setupNeedsAttention": "Setările necesită atenție",
      "setupNeedsAttentionDescription": "Una sau mai multe verificări au eșuat. Consultă elementele de mai jos sau contactează asistența Linguise.",
      "lastChecked": "Ultima verificare {{time}}",
      "domainOwnership": "Proprietatea domeniului",
      "domainOwnershipDescription": "Înregistrare de verificare găsită",
      "domainOwnershipFailure": "Înregistrarea DNS de proprietate nu a putut fi verificată.",
      "translatedHosts": "Gazde traduse",
      "translatedHostsDescription": "{{count}} gazde lingvistice verificate",
      "translatedHostsFailure": "Una sau mai multe înregistrări CNAME lingvistice sunt incorecte.",
      "subdomainPage": "Pagina subdomeniului",
      "subdomainPageDescription": "{{count}} pagini traduse acceptă HTTPS",
      "subdomainPageFailure": "Conexiunea TLS a eșuat la deschiderea uneia sau mai multor pagini traduse.",
      "originalSite": "Site-ul original",
      "originalSiteDescription": "Verificări DNS, TLS și de răspuns pentru site-ul original",
      "originalSiteFailure": "Verificarea DNS, TLS sau a răspunsului site-ului original a eșuat.",
      "documentationAdvice": {
        "dns": "Verifică setarea DNS",
        "tls": "Verifică setarea HTTPS",
        "origin": "Verifică setarea site-ului original",
        "diagnostic": "Consultă pașii de depanare"
      },
      "evidence": {
        "originDns": "DNS original",
        "originTls": "TLS original",
        "originHttp": "Răspunsul original",
        "observedTargets": "Destinații observate",
        "recordCount": "Înregistrări găsite",
        "addressCount": "Adrese găsite",
        "statusCode": "Stare HTTP",
        "redirect": "Redirecționare",
        "expiresAt": "Certificatul expiră",
        "raw": "{{key}}",
        "noValue": "Nicio valoare"
      },
      "checkerError": "Unele verificări nu au putut fi finalizate.",
      "coreLocation": "Verificat din {{location}}",
      "status": {
        "queued": "În coadă",
        "running": "În curs",
        "completed": "Finalizat",
        "failed": "Eșuat",
        "passed": "Trecut",
        "warning": "Avertisment",
        "unknown": "Necunoscut",
        "skipped": "Omise",
        "not_applicable": "Nu se aplică"
      }
    },
    "throttling": {
      "title": "Limită de traducere",
      "description": "Limite temporare de utilizare",
      "unavailable": "Limitele temporare de traducere nu sunt disponibile",
      "window": "{{used}} / {{max}} cuvinte",
      "resetsIn": "Se resetează în {{time}}",
      "throttled": "Traducerea este suspendată temporar",
      "throttledDescription": "A fost atinsă o limită temporară de utilizare. Traducerea se va relua când această perioadă se resetează."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "PAS {{step}} DIN {{total}}",
      "doneLabel": "GATA, PUTEȚI ÎNCEPE SĂ TRADUCEȚI!",
      "finish": {
        "title": "",
        "description": "Aceasta este cheia API de utilizat pe site-ul dvs."
      },
      "instructions": "Instrucțiuni de instalare",
      "domainSetting": "Setări domeniu",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "Script PHP",
        "wizardWordpressStep1": "1. Instalați ",
        "wizardWordpressStep2": "\n 2. În setările plugin-ului copiați și introduceți cheia API\n",
        "wizardWordpressStep3": "3. Sunteți gata să traduceți\n\n",
        "wizardWordpressStep4": "Pentru instrucțiuni mai detaliate, consultați documentația noastră: ",
        "wizardJoomlaStep1": "1. Linkul pachetului Joomla: ",
        "wizardJoomlaStep2": "\n2. În setările de configurare ale extensiei, copiați și completați cheia dvs. API",
        "wizardJoomlaStep3": "3. În configurația modulului, setați limbile pe care doriți să le afișați și introduceți modulul acolo unde aveți nevoie.",
        "wizardJoomlaStep4": "\n 4. Sunteți gata să traduceți\n\n",
        "wizardPhpStep1": "1. Descărcați scriptul nostru php și aici ",
        "wizardPhpStep2": "\n2. Urmați instrucțiunile de instalare de pe pagina noastră de documentație aici ",
        "wizardPhpStep3": "\n3. Adăugați modulul la paginile dvs.",
        "wizardPhpStep4": "\n Copiați următorul cod și adăugați-l în secțiunea head a paginii dvs. html; acesta va afișa automat modulul switcher\n",
        "dispatchStep1": "Am trimis cu succes datele necesare pluginului Linguise, acum puteți închide fereastra următoare.",
        "dispatchStep2": "În cazul în care tokenul lipsește când închideți această fereastră, vă rugăm să copiați următorul token:",
        "dispatchStep3": "Puteți copia, de asemenea, acest snippet pentru a activa automat comutatorul nostru de steaguri",
        "wizardOtherStep1": "Urmați instrucțiunile de mai jos pentru a instala Linguise pe domeniul dvs.\n",
        "wizardOtherStep2": "Copiați următorul cod și adăugați-l în secțiunea head a paginii dvs. html; acesta va afișa automat modulul switcher.\n"
      },
      "trialAlreadyUsed": "Se pare că ați folosit deja perioada de probă gratuită, așa că aveți nevoie de cotă de traducere\nVă rugăm să vă abonați la un plan sau să ne contactați dacă doriți să vă prelungiți perioada de probă.",
      "usefulLinks": "Linkuri utile pentru a începe",
      "linkDocumentation": "Documentație",
      "linkExtensionDl": "Descărcare extensie",
      "linkSubscribe": "Abonați-vă la un plan acum",
      "linkDashboard": "Mergeți la tabloul de bord",
      "exclusion": {
        "title": "Denumirile companiilor și produselor",
        "description": ""
      },
      "finishButton": "Finalizați configurarea",
      "subdomains": "Subdomenii",
      "subdomain_setup": "Configurați domeniul",
      "subdomain_auto_setup": "Conectați-vă DNS-ul automat",
      "subdomain_manual_setup": "Adaug eu intrările DNS",
      "subdomain_skip": "Fac mai târziu",
      "auto_subdomains_info": "Creatorul dvs. de site-uri necesită o configurație DNS pentru a seta limbile pe subdomeniu (ex. es.domeniu.com).",
      "auto_subdomains_info_2": "Puteți face acest lucru automat folosind Entri. Pur și simplu apăsați butonul „Conectați-vă DNS-ul automat” pentru a începe conectarea la managerul dvs. DNS și pentru a le adăuga cu Entri.",
      "auto_subdomains_info_manual": "Sau, vă puteți configura manual domeniul făcând clic pe butonul „Adaug eu intrările DNS”.",
      "breadcrumbs": {
        "step1": "Pasul 1: Domeniu, CMS și limbi",
        "step2": "Pasul 2: DNS-ul limbii",
        "step3": "Pasul {{step}}: Instrucțiuni de instalare"
      }
    },
    "form": {
      "urls": {
        "dash": "Liniuță -",
        "underscore": "Subliniere _",
        "title": "Traduceți URL-urile",
        "description": "Doriți să traduceți în toate paginile",
        "char_description": "Caracter de folosit pentru a înlocui caracterele neautorizate în URL-uri",
        "advertisement_title": "⚠ Ați setat multe limbi.\n",
        "advertisement": "De obicei, recomandăm să începeți traducerea site-urilor cu puține limbi mai întâi. Veți avea o idee despre câte cuvinte are site-ul dvs. Este, de asemenea, mai bun pentru SEO, deoarece roboții Google vor indexa mai rapid toate paginile dvs. dacă aveți mai puține pagini la început. După o săptămână, puteți adăuga câteva limbi în plus și tot așa."
      },
      "url": {
        "title": "Url",
        "description": "Introduceți URL-ul dvs. de domeniu principal, începând cu http:// sau https://",
        "placeholder": "URL domeniu",
        "advertisement_http": {
          "title": "Nu folosiți protocolul https",
          "description": "Vă rugăm să verificați dacă domeniul dvs. nu folosește de fapt protocolul https, care este recomandat în prezent."
        },
        "advertisement_www": {
          "title": "Subdomeniul dvs. nu este www",
          "description": "De cele mai multe ori, subdomeniul implicit este www (de exemplu https://www.domeniulmeu.com). Este posibil să nu fie cazul dvs., dar vă rugăm să verificați din nou că domeniul pe care doriți să-l adăugați este cel corect."
        },
        "invalid_url": {
          "line1": "Nu am reușit să găsim domeniul dvs. Vă rugăm să verificați că domeniul dvs. este accesibil public prin Internet și nu este redirecționat către o altă locație.",
          "line2": "Dacă sunteți sigur că domeniul dvs. este accesibil, puteți sări peste verificarea domeniului și să apăsați din nou butonul „Pasul următor”",
          "contact": "În orice caz, ne puteți contacta la",
          "force": "Sari peste verificarea domeniului"
        },
        "invalid_subdomain_url": "Această adresă URL nu este permisă. Subdomeniile trebuie să aibă forma: https://www.domeniu.tld sau https://domeniu.tld fără subdirector."
      },
      "account": {
        "title": "Cont",
        "description": "Selectați un cont pentru a atribui acest domeniu",
        "placeholder": "Selectați contul...",
        "feedback": "Trebuie să alegeți un cont"
      },
      "platform": {
        "title": "Platformă",
        "description": "Vă rugăm să selectați platforma site-ului dvs. web după numele CMS-ului.",
        "learn": "Aflați cum să-l alegeți",
        "placeholder": "Căutați platforma după numele CMS-ului...",
        "info": {
          "title": "⚠ Această platformă a fost adăugată recent.\n",
          "desc": "Această platformă de creare site-uri web este acceptată de Linguise, deși a fost adăugată recent. Dacă întâmpinați probleme, vă rugăm să ne contactați folosind adresa de e-mail de asistență directă:"
        },
        "description_read_only": "Platforma pe care o folosește site-ul dvs.",
        "feedback": "Trebuie să alegeți o platformă"
      },
      "language": {
        "title": "Limbă",
        "description": "Selectați limba de bază a site-ului dvs.",
        "placeholder": "Selectați limba...",
        "feedback": "Trebuie să alegeți o limbă",
        "description_read_only": "Limba de bază a site-ului dvs."
      },
      "token": {
        "title": "Cheie API",
        "description": "Aceasta este cheia API de copiat pe site-ul dvs.",
        "copy": "Copiați în clipboard",
        "reset": "Resetați cheia API",
        "reset_confirm": "Vă rugăm să confirmați resetarea cheii API"
      },
      "languages": {
        "title": "Limbile de tradus",
        "description": "Selectați limbile în care doriți să fie tradus site-ul dvs.",
        "placeholder": "Selectați limbile...",
        "feedback": "Trebuie să alegeți o limbă"
      },
      "defaultRules": {
        "title": "Reguli implicite",
        "description": "Am definit un set de reguli obligatorii pentru a îmbunătăți traducerea și pentru a evita traducerea conținutului nedorit, precum tabloul de bord WordPress.\nPuteți elimina sau edita aceste reguli mai târziu, dacă doriți."
      },
      "disallow_deletion": "Nu puteți șterge domeniul cu abonament activ",
      "delete_confirm": "Vă rugăm să confirmați ștergerea domeniului",
      "delete": "Șterge domeniul",
      "dynamic": {
        "title": "Traduceți conținutul dinamic",
        "description": "Conținutul dinamic generat de JavaScript și cererile AJAX vor fi traduse (Această opțiune va crește utilizările dvs. de traducere)"
      },
      "partial_translations": {
        "title": "Permiteți traducerea parțială",
        "description": "Dacă contul dvs. a atins cota de traducere, dar pagina încă necesită traducere, Linguise poate continua să afișeze pagina cu conținutul deja tradus.\nCu toate acestea, unele părți ale paginii vor rămâne netraduse până când vă veți upgrada cota.\n\nDeși o cantitate mică de conținut netradus de obicei nu afectează SEO, permiterea unui conținut netradus în cantitate mare ar putea avea un impact negativ asupra experienței utilizatorului.\nPentru a remedia aceasta, puteți seta un prag pentru procentul de conținut netradus permis pe o pagină. Dacă conținutul netradus depășește acest prag, utilizatorii vor fi redirecționați automat către versiunea în limba originală a paginii.",
        "never": "Niciodată"
      },
      "translate_error_pages": {
        "title": "Traduceți paginile de eroare",
        "description": "Linguise poate traduce toate paginile de eroare, totuși, dacă pagina dvs. de eroare conține conținut dinamic, precum adresa IP sau ID-ul cererii, ar trebui să evitați traducerea acestor pagini.",
        "not_found_page": {
          "title": "Traduceți pagina 404"
        },
        "error_page": {
          "title": "Traduceți celelalte pagini de eroare"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Domeniu existent găsit",
          "description": "A fost găsit un domeniu existent pentru acest utilizator, doriți să-l folosiți?"
        }
      },
      "search_tl": {
        "title": "Căutați traduceri",
        "description": "Activați căutarea traducerilor pentru platforma site-ului dvs. web (Experimental, această opțiune va crește utilizările dvs. de traducere)"
      },
      "shopify_promo": {
        "info": "Vești bune! Acum avem o aplicație nativă Shopify pe care o puteți instala din magazinul de aplicații Shopify.",
        "hyperlink": "Apasă aici și instalează Linguise din aplicație.",
        "next_btn": "Accesați magazinul Shopify pentru a instala aplicația",
        "info_legacy": "Vești bune! Acum avem o aplicație nativă Shopify pe care o puteți instala din magazinul de aplicații Shopify.",
        "description_legacy": "Selectați platforma „Shopify” în loc de „Shopify Legacy”"
      },
      "wix_promo": {
        "info": "Vești bune! Acum avem o aplicație nativă Wix pe care o puteți instala din magazinul de aplicații Wix.",
        "hyperlink": "Apasă aici și instalează Linguise din aplicație.",
        "next_btn": "Accesați Wix App Market pentru a instala aplicația",
        "info_legacy": "Vești bune! Acum avem o aplicație nativă Wix pe care o puteți instala din magazinul de aplicații Wix.",
        "description_legacy": "Selectați platforma „Wix” în loc de „Wix Legacy”"
      },
      "ai_disallow_deletion": "Nu puteți șterge acest domeniu cât timp este încă disponibilă o cotă AI.\n\nVă rugăm să contactați echipa noastră de asistență dacă doriți să ștergeți acest domeniu la",
      "language_removal": {
        "card": {
          "title": "Șterge traducerile limbilor eliminate",
          "description": "Aceste limbi au fost eliminate de pe site-ul tău, dar traducerile salvate încă se scad din cota ta. Șterge-le pentru a recupera cuvintele.",
          "button": "Șterge traducerile"
        },
        "hint": "Cuvintele folosite vor fi returnate în cota ta. Poți face acest lucru o dată la {{days}} zile pentru fiecare site.",
        "modal": {
          "title": "Ștergi traducerile?",
          "intro": "Aceste traduceri vor fi șterse definitiv:",
          "warning": "Acțiunea nu poate fi anulată. Cuvintele folosite vor fi returnate în cota ta, iar procesul poate dura câteva minute.",
          "limit": "Poți face acest lucru o dată la {{days}} zile pentru fiecare site.",
          "confirm": "Șterge traducerile"
        },
        "scheduled": "Traducerile sunt în curs de ștergere, iar cota ta va fi actualizată în curând.",
        "cooldown": "Traducerile acestui site au fost șterse recent. Le poți șterge din nou pe {{date}}.",
        "latest_completed": {
          "title": "Ultima ștergere finalizată",
          "description": "Vezi limbile șterse și cuvintele returnate în cota ta.",
          "languages": "Limbi șterse",
          "words_returned": "Cuvinte returnate în cotă: {{words}}",
          "completed_at": "Finalizat la {{date}}"
        },
        "status": {
          "recent_title": "Ștergere recentă a traducerilor",
          "recent_description": "Urmărește ultima ștergere și află când va fi disponibilă următoarea.",
          "progress_title": "Progresul ștergerii",
          "loading": "Se verifică progresul ștergerii...",
          "unavailable": "Progresul ștergerii nu a putut fi încărcat. Reîncarcă pagina și încearcă din nou.",
          "label": "Stare",
          "pending": "În coadă",
          "processing": "În desfășurare",
          "completed": "Finalizat",
          "failed": "Eșuat",
          "unknown": "Starea nu este disponibilă",
          "percent": "{{percent}}% finalizat",
          "current_stage": "Etapa curentă: {{stage}}",
          "processed": "{{processed}} înregistrări procesate",
          "processed_total": "{{processed}} din {{total}} înregistrări procesate",
          "requested_at": "Solicitat la {{date}}",
          "started_at": "Început la {{date}}",
          "completed_at": "Finalizat la {{date}}",
          "cooldown_period": "Poți face acest lucru o dată la {{days}} zile pentru fiecare site.",
          "cooldown_blocked": "Nu poți începe încă o altă ștergere.",
          "stage": {
            "queued": "În așteptarea începerii",
            "processing": "În desfășurare",
            "refund_summary": "Se calculează cuvintele returnate",
            "search_translations": "Se șterg traducerile de căutare",
            "url_translations": "Se șterg traducerile URL",
            "translations": "Se șterg traducerile",
            "completed": "Finalizat",
            "failed": "Eșuat",
            "unknown": "În desfășurare"
          }
        },
        "forbidden": "Nu ai permisiunea de a șterge traduceri."
      }
    },
    "main": {
      "edit": "Editați domeniul",
      "add": "Adăugați domeniu",
      "wizard": "Bun venit! Expertul pentru crearea unui domeniu nou",
      "common": "Domeniu"
    },
    "notice": {
      "broken_card": "Nu am reușit să reînnoim planul dvs. pentru {{url}} folosind metoda de plată actuală, vă rugăm să vă actualizați cardul de plată",
      "quota_reached": "Cota dvs. de traducere pentru {{url}} a fost atinsă, vă rugăm să faceți upgrade pentru a relua traducerea site-ului",
      "ai_no_subscription": "Traducerea AI pentru {{url}} necesită un abonament activ sau o perioadă de probă activă. Se va opri fără unul, vă rugăm să faceți upgrade pentru a continua",
      "important": "Important",
      "quota_reached_button": "Upgradează-ți planul acum",
      "broken_card_button": "Actualizează cardul de plată",
      "ai_no_subscription_button": "Upgradează-ți planul acum",
      "quota_warning": "Cota de traducere pentru {{url}} a atins {{throttling_used_percent}}%, aceasta se va reseta în {{ttl}}",
      "locked": "Domeniul {{url}} este în prezent blocat pentru migrare, vă puteți accesa în continuare site-ul, dar nu puteți edita sau adăuga traduceri noi!"
    },
    "subdomains": {
      "config_ok": "DNS-ul subdomeniilor a fost configurat corect.",
      "config_invalid": "DNS-ul subdomeniilor necesită o configurație suplimentară pentru a funcționa.",
      "config_check": "Se verifică configurația DNS a subdomeniilor, te rugăm să aștepți...",
      "entri_timeout": "Entri a raportat că procesul de propagare DNS pentru subdomeniile tale a expirat; va trebui să reîncerci sau să îl faci manual.",
      "entri_process": "DNS-ul tău a fost adăugat cu Entri și, de regulă, durează 10-30 minute să se propage (se aplice toate subdomeniile de limbi, precum es.domeniu.ro). Dacă validarea DNS nu este finalizată după 24 ore, ne poți contacta la: support@linguise.com",
      "entri_ok": "Propagarea DNS este în curs! Se așteaptă propagarea...",
      "infos": "Trebuie să adăugați aceste intrări DNS la înregistrările domeniului DNS pentru a activa traducerea. Faceți clic pe butonul de verificare după ce ați terminat. Este posibil ca înregistrările DNS să dureze ceva timp pentru a se propaga, așa că este posibil să fie nevoie să reveniți după câteva minute sau ore.",
      "check": "Verificați configurația DNS"
    },
    "subscription": {
      "next_payment_amount": "Taxele viitoare",
      "next_payment_date": "Data următoarei plăți",
      "invoice": {
        "header": "Istoric facturi",
        "date": "Dată",
        "amount_due": "Sumă",
        "status": "Stare",
        "actions": "Acțiuni",
        "description": "După ce tranzacțiile sunt disponibile, le poți vizualiza aici.",
        "status_text": {
          "draft": "Ciornă",
          "failed": "Eșuat",
          "open": "În așteptare",
          "paid": "Plătit",
          "retrying": "Se reîncearcă",
          "uncollectible": "Incolectabil",
          "void": "Anulat"
        },
        "view": "Vizualizează",
        "empty": "Nu a fost găsită nicio factură recentă pentru acest abonament",
        "retry_payment": "Reîncearcă"
      },
      "next_cancellation": "Data anulării",
      "cancel": "Anulează abonamentul",
      "change_plan": "Schimbă planul",
      "change": "Schimbă",
      "suspend": "Suspendă plata",
      "resume": "Reactivează abonamentul",
      "back": "Înapoi",
      "save": "Salvează",
      "confirm_resume": "Sigur vrei să reactivezi acest abonament?",
      "confirm_cancel": "Sigur vrei să anulezi acest abonament?",
      "confirm_header": "Ești sigur?",
      "missing_status": "Acest abonament lipsește",
      "not_found": "Nu a fost găsit niciun abonament pentru acest domeniu",
      "confirm_manual_retry": "Sigur vrei să reîncerci această plată?",
      "no_payment_method": "Necunoscut",
      "remove_billing": "Elimină",
      "shopify_maneged": "Acest abonament este gestionat de Shopify. Te rugăm să îl administrezi din panoul tău Shopify.",
      "unknown_plan": "Plan necunoscut"
    }
  },
  "domain_listing": {
    "add": "Adaugă site web",
    "select": "Alege un domeniu"
  },
  "editable": {
    "number": "numărul {{id}}"
  },
  "footer": {
    "about": "Despre",
    "support": "Asistență"
  },
  "frontendEditor": {
    "main": "Editor Live",
    "description": "Editorul Live te ajută să editezi direct traducerile de pe site-ul tău.",
    "button": "Deschide Editorul Live",
    "language_selection": "Selecția limbii de traducere",
    "video_label": "Află cum să folosești editorul live"
  },
  "general": {
    "403": {
      "tab_title": "Ups - Eroare 403",
      "title": "Acces refuzat",
      "message": "Se pare că nu ai acces la pagina solicitată.",
      "home": "Înapoi la pagina principală"
    },
    "404": {
      "tab_title": "Ups - Eroare 404",
      "title": "Pagina nu a fost găsită",
      "message": "Se pare că ai luat-o pe un drum greșit. Nu te îngrijora... li se întâmplă și celor mai buni dintre noi. Iată un mic sfat care te poate ajuta să revii pe drumul cel bun.",
      "home": "Înapoi la pagina principală"
    },
    "500": {
      "tab_title": "Eroare 500",
      "title": "Eroare internă de server",
      "message": "De ce nu încerci să reîmprospătezi pagina? Sau ne poți contacta",
      "home": "Înapoi la pagina principală"
    },
    "fields": {
      "alert": "Unele câmpuri nu sunt valide; te rugăm să corectezi câmpurile invalide.",
      "invalid": "Acest câmp este invalid",
      "phone_re": "Numărul de telefon este invalid",
      "phone_invalid": "Numărul de telefon este invalid",
      "email": "Câmpul de e-mail este invalid"
    },
    "table": {
      "no_data": "Nu există încă date aici..."
    },
    "saving": "Se salvează ...",
    "save": "Salvează",
    "save_and_quit": "Salvează și ieși",
    "invite": "Invită",
    "cancel": "Anulează",
    "yes": "Da",
    "no": "Nu",
    "nextStep": "Pasul următor",
    "loading": "Te rugăm să aștepți până se încarcă aplicația",
    "goback": "Înapoi",
    "manage": "Gestionează",
    "delete": "Șterge",
    "deleting": "Se șterge ...",
    "confirm": "Confirmă",
    "unknown": "Necunoscut",
    "hide": "Ascunde",
    "show": "Spectacol",
    "on": "Pe",
    "off": "Dezactivat",
    "default": "Implicit"
  },
  "home": {
    "header": "Acasă",
    "manage": "Gestionează abonamentul",
    "canceled": "Programat pentru anulare",
    "activate_now": "Activează acum",
    "activate_plan_now": "Abonează-te acum",
    "upgrade_plan_now": "Upgradează planul acum",
    "trial_message_part_1": "Momentan ești pe planul de încercare, ",
    "trial_message_part_2": "poți activa un abonament oricând.",
    "add": "Adaugă domeniu",
    "table": {
      "title": "Domenii",
      "description": "Lista domeniilor tale; dă clic pe domeniu pentru a gestiona traducerile"
    },
    "domains": {
      "empty": "Nu ai niciun domeniu în acest cont"
    },
    "accountsList": {
      "title": "Conturi",
      "add": "Adaugă cont nou",
      "name": "Numele contului"
    },
    "update_credit_card": "Actualizați detaliile cardului de credit",
    "cancelling_subs": "Se anulează la {{0}}",
    "resume_subscription": "Reluați abonamentul",
    "shopify_managed": "Administrat de Shopify",
    "trial_ends_at": "Se încheie la {{0}}",
    "free_trial": "Probă gratuită",
    "no_subs": "Nicio abonare activă"
  },
  "invoices": {
    "title": "Facturi",
    "list": {
      "title": "Listă facturi"
    },
    "table": {
      "customer": "Client",
      "domain": "Domeniu",
      "amountPaid": "Sumă plătită",
      "status": "Status",
      "date": "Dată",
      "invoice": "Factură",
      "pay": "Plătiți factura",
      "actions": "Acțiuni",
      "deleted_domain": "Domeniu șters",
      "plan_name": "Plan",
      "action": "Acțiune"
    },
    "listPending": {
      "title": "Listă facturi în așteptare"
    }
  },
  "language_settings": {
    "display": "Afișare listă limbi",
    "position": "Poziție",
    "display_help_text": "Afișați steag și/sau numele limbilor. Poziția implicită a selectorului de limbă poate fi oriunde în conținut sau într-o poziție fixă care rămâne fixă sau se mișcă la derulare",
    "side_by_side": "Unul lângă altul",
    "dropdown": "Listă derulantă",
    "popup": "Fereastră pop-up",
    "flag": "Steag",
    "lang_name": "Numele limbii",
    "lang_short_name": "Numele scurt",
    "positions": {
      "in_place": "La loc",
      "top_left": "Sus stânga",
      "top_left_no_scroll": "Sus stânga (fără derulare)",
      "top_right": "Sus dreapta",
      "top_right_no_scroll": "Sus dreapta (fără derulare)",
      "bottom_left": "Jos stânga",
      "bottom_left_no_scroll": "Jos stânga (fără derulare)",
      "bottom_right": "Jos dreapta",
      "bottom_right_no_scroll": "Jos dreapta (fără derulare)"
    },
    "lang_names_display": {
      "title": "Afișarea numelor limbilor",
      "help_text": "În selectorul de limbă, afișați numele limbilor în engleză sau în limba originală, adică French sau Français",
      "english": "Engleză",
      "native_languages": "Limbi native"
    },
    "flag_shape": {
      "title": "Stil steag",
      "help_text": "Utilizați steaguri svg rotunde sau dreptunghiulare",
      "round": "Rotund",
      "rectangular": "Dreptunghiular"
    },
    "english_flag_type": {
      "title": "Tip steag englez",
      "help_text": "Utilizați steagul Marii Britanii sau al SUA pentru engleză",
      "usa": "Steag SUA",
      "great_britain": "Steagul Marii Britanii"
    },
    "german_flag_type": {
      "title": "Tip steag german",
      "help_text": "Utilizați steagul Austriei sau al Germaniei pentru germană",
      "german": "Steag german",
      "austria": "Steag austriac"
    },
    "spain_flag_type": {
      "title": "Tip steag spaniol",
      "help_text": "Utilizați steagul Mexicului sau al Spaniei pentru spaniolă",
      "spanish": "Steag spaniol",
      "mexico": "Steag mexican",
      "peruvian": "Steag peruan"
    },
    "portugal_flag_type": {
      "title": "Tip steag portughez",
      "help_text": "Utilizați steagul Portugaliei sau al Braziliei pentru portugheză",
      "portugal": "Steag portughez",
      "brazil": "Steag brazilian"
    },
    "taiwanese_flag_type": {
      "title": "Tip steag taiwanez",
      "help_text": "Utilizați steagul Taiwanului sau al Chinei pentru taiwaneză",
      "taiwanese": "Steag taiwanez",
      "chinese": "Steag chinez"
    },
    "flag_border_radius": {
      "title": "Raza marginii steagului (px)",
      "help_text": "Dacă folosiți forma dreptunghiulară a steagului, puteți aplica o rază personalizată a marginii în pixeli"
    },
    "flag_width": {
      "title": "Dimensiune steag (px)",
      "help_text": "Selectați dimensiunea steagurilor în pixeli. Aceasta nu modifică greutatea imaginii, deoarece este un format .svg"
    },
    "lang_color": {
      "color_title": "Culoarea numelui limbii",
      "color_help_text": "Selectați o culoare implicită pentru numele limbilor",
      "hover_color_title": "Culoare la hover pentru numele limbii",
      "hover_color_help_text": "Selectați o culoare a textului la trecerea mouse-ului pentru numele limbilor",
      "color_popup_title": "Culoarea limbii din popup",
      "color_popup_help_text": "Culoarea titlului limbii în popup sau în zonele dropdown",
      "hover_color_popup_title": "Culoare hover limbă popup",
      "hover_color_popup_help_text": "Selectați o culoare a textului la trecerea mouse-ului pentru titlul limbii din popup sau dropdown"
    },
    "flag_box_shadow": {
      "shadow_title": "Umbra steagului",
      "shadow_help_text": "Culoarea și dimensiunea umbrei pentru steagurile limbii",
      "hover_shadow_title": "Umbra steagului la hover",
      "hover_shadow_help_text": "Culoarea și dimensiunea umbrei pentru steagurile limbii la trecerea mouse-ului",
      "shadow_h_offset": "Offset orizontal umbră (px)",
      "shadow_v_offset": "Offset vertical umbră (px)",
      "shadow_blur": "Estompare umbră (px)",
      "shadow_spread": "Răspândire umbră (px)",
      "shadow_color": "Culoarea umbrei"
    },
    "order": "Ordinea limbilor",
    "language_order_help": "Ordinea limbii care va fi afișată în selectorul de limbă. Puteți trage și plasa limba pentru a le reordona.",
    "order_reset": "Resetare ordine",
    "language_order_dragdrop": "Puteți trage și plasa limba pentru a le reordona.",
    "popup_lang_name": "Numele limbii în popup",
    "preview": "Previzualizare limbă"
  },
  "link": {
    "form": {
      "original": {
        "title": "Sursa originală",
        "description": "Adăugați URL-ul linkului original și înlocuiți-l mai jos pentru fiecare limbă pentru a le traduce",
        "srcset_description": "Editați un URL de imagine. Vă rugăm să citiți documentația, mai ales dacă folosiți srcset sau nu știți ce este",
        "link": "Legătură",
        "match_link": "Mod potrivire",
        "match_exact": "Exact",
        "match_wildcard": "Caracter generic",
        "match_regex": "Expresie regulată"
      },
      "alternative_languages": {
        "title": "Legături de înlocuit",
        "description": "Înlocuiește legăturile media și cele externe de pe pagini, pe limbi…",
        "link": "Legătură de înlocuit"
      },
      "error": {
        "atLeastOne": "Adaugă cel puțin o traducere.",
        "url": "URL-ul este incorect",
        "extension": "Legătura trebuie să aibă o extensie, dar nu poate fi .html sau .php. De asemenea, nu trebuie să conțină o cale de limbaj, ex. \"/fr\"",
        "regex": "Regex-ul este incorect",
        "wildcard": "Legătura wildcard are un protocol incorect"
      }
    },
    "main": {
      "parent": "Legături",
      "edit": "Editează legătura"
    }
  },
  "links": {
    "title": "Gestionarea legăturilor media și externe",
    "description": "Afișează și editează legăturile media sau externe ale site-ului.",
    "add": "Adaugă legătură",
    "delete": "Șterge legătura",
    "table": {
      "original": "Original",
      "language": "Limbă",
      "translation": "Traducere",
      "action": "Acțiune",
      "delete_confirm": "Confirmă ștergerea legăturii"
    }
  },
  "members": {
    "header": "Membri",
    "invite": "Invită un membru nou",
    "modal": {
      "inviteHeader": "Invită un membru nou",
      "editHeader": "Editează membrul",
      "detachHeader": "Detașează membrul",
      "detachBody": "Sigur vrei să detașezi membrul de la acest cont?",
      "selfDetachBody": "Sigur vrei să te detașezi de la administrarea acestui cont? După aceea, nu vei mai putea accesa nicio informație legată de acest cont."
    },
    "table": {
      "title": "Lista membrilor",
      "description": "Rolurile membrilor și accesul la domenii",
      "name": "Nume",
      "email": "E-mail",
      "websites": "Site-uri web",
      "languages": "Limbi",
      "role": "Rol",
      "status": "Stare",
      "resendInvite": "retrimite",
      "inviteSent": "invitația a fost trimisă",
      "actions": "Acțiuni",
      "edit": "Editează",
      "detach": "Detachează",
      "empty": "Nu ai niciun membru încă",
      "all_website": "Toate site-urile și limbile",
      "roles": {
        "admin": "Administrator",
        "manager": "Manager",
        "translator": "Traducător"
      },
      "statuses": {
        "pending": "În așteptare",
        "accepted": "Acceptat",
        "declined": "Respins"
      }
    },
    "errors": {
      "role": "Trebuie să alegi un rol",
      "domains": "Trebuie să alegi cel puțin 1 site web pentru rolul selectat",
      "languages": "Trebuie să alegi cel puțin 1 limbă pentru site-urile web selectate"
    },
    "inviteSent": "Invitația ta a fost trimisă cu succes"
  },
  "pagination": {
    "showing": "Se afișează {{limit}} din {{total}} rezultate",
    "showing_only_count": "Se afișează {{limit}} rezultate"
  },
  "payments_method": {
    "header": "Metode de plată",
    "table": {
      "title": "Lista metodelor de plată",
      "description": "Metodele de plată atașate contului tău",
      "default": "Implicit",
      "action_edit_remove": "Editează sau elimină",
      "action_remove": "Elimină",
      "action_default": "Setează ca implicit",
      "action_fallback": "Setează ca alternativă",
      "expires": "Expiră",
      "add_new_card": "Adaugă metodă de plată",
      "action_fallback_remove": "Elimină din alternative",
      "fallback": "Alternativă",
      "action_edit": "Editează",
      "action_delete": "Șterge",
      "action_default_remove": "Elimină ca implicit",
      "domain_count@@one": "Folosit de {{count}} domenii",
      "domain_count@@other": "Utilizat de {{count}} domenii"
    },
    "paypal_bind": {
      "button": "Conectează cont PayPal",
      "button_load": "Se conectează...",
      "disconnected": "Neconectat",
      "success": "Contul tău PayPal este acum conectat; 5 $ vor fi deduși de la următoarea factură!",
      "success_no_promo": "Contul tău PayPal este acum conectat",
      "error": "A apărut o eroare",
      "success_header": "Succes"
    },
    "card_add": {
      "header": "Adaugă card nou",
      "success": "Card nou conectat la Linguise!",
      "terms": "Furnizând datele cardului, permiți să-l taxăm pentru plățile viitoare, conform termenilor noștri de serviciu."
    },
    "card_detail": {
      "header": "Informații card",
      "delete": {
        "error": "Nu poți șterge această metodă de plată deoarece are abonamente active!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Abonamente la această metodă de plată",
        "header_domain": "Domeniu",
        "header_plan": "Plan",
        "header_status": "Stare",
        "header_actions": "Acțiuni",
        "cancelling": "Se anulează la: {{0}}",
        "next_payment": "Următoarea plată la: {{0}}",
        "action_renew": "Reînnoiește",
        "no_subs_header": "Nu există abonamente de afișat",
        "no_subs_desc": "Odată ce se creează un abonament la acest card, toate informațiile vor apărea aici",
        "action_manage": "Gestionează"
      },
      "status": {
        "active": "Activ",
        "canceled": "Anulat",
        "incomplete": "Neplătit",
        "incomplete_expired": "Neplătit (Expirat)",
        "missing": "Eroare",
        "past_due": "Întârziat",
        "trialing": "În perioadă de probă",
        "unpaid": "Neplătit"
      }
    },
    "delete_confirm_body": "Sigur vrei să ștergi această metodă de plată? Această acțiune nu poate fi anulată!",
    "delete_confirm_header": "Șterg metoda de plată?",
    "card_edit": {
      "header": "Editează cardul",
      "billing_header": "Informații de facturare",
      "address_error": "Adresa este obligatorie!",
      "card_number": "Număr card",
      "card_expiry": "Data expirării",
      "expiry_error_month": "Lună invalidă furnizată",
      "expiry_error_year": "An invalid furnizat",
      "expiry_error_expired": "Anul de expirare al cardului tău este în trecut.",
      "card_header": "Informații despre card",
      "expiry_error_empty": "Acest câmp este obligatoriu!"
    }
  },
  "plans": {
    "per": "pe",
    "wordsTranslated": "cuvinte traduse",
    "current": "Actual",
    "archived": "Arhivat",
    "day": "zi",
    "week": "săptămână",
    "month": "lună",
    "year": "an",
    "activate": "Activează",
    "cancel": "Anulează",
    "change": "Schimbă",
    "upgrade": "Trecere la plan superior",
    "downgrade": "Trecere la plan inferior",
    "resume": "Reluare",
    "notEnoughWords": "Cuvinte insuficiente",
    "yearIntervalOnly": "Nu se poate migra de la abonamentul anual",
    "subsCanceled": "Există o altă anulare de abonament în curs",
    "wordsUnlimited": "Cuvinte nelimitate",
    "tabs": {
      "day": "Prețuri zilnice",
      "week": "Prețuri săptămânale",
      "month": "Prețuri lunare",
      "year": "Prețuri anuale",
      "sub_texts": {
        "day": "Un preț fix, în fiecare zi",
        "week": "Un preț fix, în fiecare săptămână",
        "month": "Un preț fix, în fiecare lună",
        "year": "O lună gratuită, o factură pe an"
      }
    },
    "details": {
      "new_languages": "Adaugă noi limbi oricând",
      "one_month_trial": "O lună gratuită pentru fiecare site nou",
      "multi_content_indexed": "100% din conținutul multilingv este indexat",
      "translate_new_content": "Tradu conținut nou instantaneu",
      "free_installation": "Instalare și configurare gratuite",
      "compared_monthly_plan": "O lună gratuită față de abonamentele lunare",
      "risk_free_recurring": "Plată recurentă fără riscuri",
      "unlimited_languages": "Limbi și afișări de pagină nelimitate",
      "high_server_resources": "Resurse server superioare",
      "billed": {
        "day": "Facturat zilnic",
        "week": "Facturat săptămânal",
        "month": "Facturat lunar",
        "year": "Facturat anual"
      },
      "request_max_size": "{{0}} dimensiune maximă cerere"
    },
    "frequent_question": {
      "title": "Întrebări frecvente",
      "questions": {
        "trial": {
          "question": "Pot folosi perioada de probă pe un domeniu nou?",
          "answer": "Da, oferim o perioadă de încercare gratuită de 30 de zile pentru fiecare domeniu nou adăugat în contul tău. Astfel, poți testa complet serviciul de traducere pe noul tău site."
        },
        "seo": {
          "question": "Cât timp durează până să-mi îmbunătățească SEO-ul?",
          "answer": "Conținutul, în special cel multilingv, necesită timp pentru a fi indexat complet și clasat bine. În funcție de traficul și dimensiunea site-ului, durează între 3 și 6 săptămâni."
        },
        "quota": {
          "question": "Sunt incluse traducerile umane în cotă?",
          "answer": "Nu, limita de cuvinte se aplică doar traducerilor automate. Un traducător poate modifica manual traducerile automate fără limită."
        }
      }
    },
    "best_offer": "Cea mai bună ofertă",
    "period": {
      "days@@one": "zi",
      "days@@other": "{{count}} zile",
      "hours@@one": "oră",
      "hours@@other": "{{count}} ore",
      "minutes@@one": "minut",
      "minutes@@other": "{{count}} minute",
      "seconds@@one": "secundă",
      "seconds@@other": "{{count}} secunde"
    },
    "words": {
      "billion": "{{value}} miliarde",
      "million": "{{value}} milioane",
      "thousand": "{{value}} mii"
    },
    "throttling_info": "{{words}} cuvinte per {{period}}"
  },
  "profile": {
    "welcome": "Bun venit!",
    "account": "Contul meu",
    "subscriptions": "Abonamente",
    "logout": "Deconectare"
  },
  "register": {
    "errors": {
      "password": "Minim 8 caractere, orice caracter"
    }
  },
  "route": {
    "dashboard": "Panou de control",
    "rules": "Reguli",
    "translations": "Traduceri",
    "search_translations": "Interogări de căutare",
    "urls_translations": "Traduceri URL",
    "links": "Linkuri media și externe",
    "online_editor": "Editor live",
    "settings": "Setări",
    "domain": {
      "finish": "Setări",
      "preconfig": "Setări"
    },
    "home": "Acasă",
    "domain_list": "Listă domenii",
    "members": "Membri",
    "invoices": "Facturi",
    "billing": "Detalii de facturare",
    "language_display": "Afișare steaguri limbă",
    "payment_methods": "Metode de plată",
    "ai_translation": "Traducere AI",
    "ai_translation_settings": "Setări",
    "ai_translation_pricing": "Prețuri"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Text de ignorat",
        "add": "Adaugă nou",
        "title": "Text de ignorat",
        "description": "Adaugă unul sau mai multe texte de ignorat",
        "ignore_case": "Ignoră majuscule"
      },
      "html_content": {
        "title": "Aplică conținutului HTML",
        "description": "Aplică regula pe tot conținutul sau selectând un selector CSS specific",
        "all_page": "Toată pagina",
        "css_selector": "Selector CSS",
        "label": "Selector CSS",
        "placeholder": "Selector la care să se aplice",
        "add": "Adaugă nou"
      },
      "apply_to_urls": {
        "title": "Aplică la URL-uri",
        "description": "Selectează URL-uri specifice unde dorești să se aplice regula",
        "all_urls": "Toate URL-urile",
        "selected_urls": "URL-uri selectate",
        "label": "URL la care se aplică",
        "placeholder": "URL la care se aplică",
        "original_url": "URL-uri originale",
        "translated_url": "URL tradus",
        "wildcard": "Caracter generic",
        "regex": "Expresie regulată",
        "add": "Adaugă nou",
        "expression": "Tip expresie"
      },
      "apply_urls": {
        "title_exclude": "Exclude din URL-uri",
        "title_replace": "Înlocuiește în URL-uri",
        "title_description": "Aplică această regulă și pentru traducerea URL-urilor"
      },
      "apply_languages": {
        "title": "Aplică la limbi",
        "description": "Selectează limba specifică unde dorești să se aplice regula",
        "all_languages": "Toate limbile",
        "selected_languages": "Limbile selectate",
        "placeholder": "Selectează limbi...",
        "feedback": "Trebuie să alegi o limbă"
      },
      "name": {
        "title": "Titlu",
        "description": "Dă un titlu regulii tale pentru comoditate",
        "placeholder": "Numele regulii"
      },
      "type": {
        "title": "Tip",
        "description": "Alege tipul de regulă pe care vrei să-l adaugi",
        "text_ignore": "Ignorare text",
        "text_replace": "Înlocuire text",
        "content_exclusion": "Excludere conținut",
        "url_exclusion": "Excludere după URL",
        "ignore_inline": "Ignorare inline",
        "full_description": {
          "text_ignore": "Adaugă reguli pentru a evita traducerea unui text. Poate fi numele produsului, numele brandului sau alte elemente tehnice pe care nu dorești să fie traduse.",
          "text_replace": "Înlocuirea textului permite înlocuirea unui text cu traducerea dorită; poate fi necesară atunci când traducerea ignoră contextul.",
          "content_exclusion": "Excluderea conținutului te va ajuta să eviți traducerea unei părți din pagină.\n Dacă dorești să excluzi complet o pagină de la traducere (fără deloc URL multilingv și fără conținut tradus), folosește tipul „Excludere după URL”.",
          "url_exclusion": "Excluderea traducerii paginii te va ajuta să stabilești paginile pe care nu dorești să fie traduse.",
          "ignore_inline": "Evită traducerea unui conținut ca inline; traduce fiecare etichetă separat."
        }
      },
      "text_replace": {
        "title": "Text de înlocuit",
        "description": "Înlocuiește un text cu traducerea ta specifică. Înlocuiește orice text pe paginile tale, în funcție de limbă…",
        "text_to_replace": "Text de înlocuit",
        "ignore_case": "Ignoră majuscule",
        "text_type": "Înlocuire în traducere",
        "text_type_original": "Original",
        "text_type_translation": "Traducere",
        "keep_case": "Încearcă să păstrezi majusculele",
        "add": "Adaugă nou"
      },
      "content_exclusion": {
        "title": "Excludere conținut",
        "description": "Selectează unul sau mai mulți selectori CSS care nu vor fi traduși",
        "label": "Selector CSS",
        "placeholder": "Selector de aplicat",
        "add": "Adaugă nou"
      },
      "multilingual_url": {
        "title": "Folosește URL multilingv",
        "description": "Dacă este setat Da, URL-ul NU va fi tradus, dar pagina va rămâne multilingvă cu conținut tradus",
        "live_example_title": "Exemplu live",
        "live_example_description": "URL sursă: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "URL generat: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "URL generat: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Aplică regula pe conținut static sau conținut dinamic sau ambele",
        "title": "Aplică la conținut",
        "all": "Tot conținut",
        "static": "Conținut static",
        "dynamic": "Conținut dinamic"
      },
      "force_apply_urls": {
        "title_description": "Aplică forțat această regulă la toate traducerile URL-urilor, inclusiv la traducerile existente!",
        "title_replace": "Forțază înlocuirea în URL-uri",
        "title_exclude": "Forțază excluderea în URL-uri",
        "warning": "Avertisment",
        "warning_part1": "Setarea acestei opțiuni la „Da” poate strica traducerile URL-urilor site-ului tău.",
        "warning_part2": "Aceasta poate genera temporar sau permanent o pagină 404; continuă doar dacă înțelegi consecințele.",
        "warning_replacement_original": "Avertizare suplimentară: Încerci să înlocuiești conținutul original care ar putea afecta URL-ul; traducerea ar putea eșua deoarece Linguise nu poate găsi corect URL-urile originale."
      }
    },
    "main": {
      "parent": "Reguli",
      "edit": "Editează regula",
      "add": "Regulă nouă"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "„{{text_ignore}}” va fi ignorat în conținut și în URL",
      "preview_single": "„{{text_ignore}}” va fi ignorat în conținut",
      "preview_more_with_url": "„{{text_ignore}}” și încă {{count}} vor fi ignorate în conținut",
      "preview_more": "„{{text_ignore}}” și încă {{count}} vor fi ignorate în conținut",
      "other_parameters": "Se aplică și alți parametri pentru această regulă; apasă butonul de editare pentru mai multe informații"
    },
    "text_replace": {
      "preview_single_with_url": "„{{original}}” este înlocuit cu „{{replacement}}” în conținut și în URL-uri",
      "preview_single": "„{{original}}” este înlocuit cu „{{replacement}}” în conținut",
      "preview_more_with_url": "„{{original}}” este înlocuit cu „{{replacement}}” în conținut și în URL-uri, și încă {{nb}}",
      "preview_more": "„{{original}}” este înlocuit cu „{{replacement}}” în conținut, și încă {{nb}}",
      "other_parameters": "Se aplică și alți parametri pentru această regulă; apasă butonul de editare pentru mai multe informații"
    },
    "content_exclusion": {
      "selectors": "{{nb}} selector(i) CSS exclus(e) de la traducere",
      "other_parameters": "Se aplică și alți parametri pentru această regulă; apasă butonul de editare pentru mai multe informații"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL-uri sunt excluse de la traducere, dar păstrează prefixul multilingv",
      "some": "{{nb}} URL-uri sunt complet excluse de la traducere",
      "all_multilingual": "toate URL-urile sunt excluse de la traducere, dar păstrează prefixul multilingv",
      "all": "toate URL-urile sunt complet excluse de la traducere",
      "other_parameters": "Se aplică și alți parametri pentru această regulă; apasă butonul de editare pentru mai multe informații"
    },
    "ignore_inline": {
      "elements": "Tot conținutul inline va fi tradus ca și conținut de bloc în pagină",
      "all_elements": "Unele conținuturi inline vor fi traduse ca și conținut de bloc în pagină",
      "other_parameters": "Alți parametri sunt setați pentru această regulă, faceți clic pe butonul de editare pentru a obține mai multe informații."
    },
    "title": "Gestionarea regulilor",
    "description": "Gestionează exclusiunile și înlocuirile de conținut pentru traducerile tale în tot site-ul",
    "add": "Adaugă regulă nouă",
    "table": {
      "title": "Titlu",
      "no_data": "Nu există încă reguli aici",
      "type": "Tip",
      "preview": "Previzualizare regulă",
      "action": "Acțiune",
      "delete_confirm": "Te rugăm să confirmi ștergerea regulii",
      "types": {
        "text_ignore": "Ignorare text",
        "text_replace": "Înlocuire text",
        "content_exclusion": "Excludere conținut",
        "url_exclusion": "Excludere URL",
        "ignore_inline": "Ignorare în linie",
        "unknown": "Regulă necunoscută"
      }
    },
    "apply_on_content": {
      "static": "Această regulă se va aplica doar conținutului static",
      "dynamic": "Această regulă se va aplica doar conținutului dinamic"
    }
  },
  "search_translations": {
    "title": "Gestionarea interogărilor de căutare",
    "description": "Afișează toate traducerile site-ului utilizate în formularele de căutare (din limba tradusă spre limba de bază a domeniului)",
    "filter_languages": "Filtrează după limbi...",
    "filter_original": "Filtrează textul în limba originală",
    "filter_translation": "Filtrează după text tradus",
    "table": {
      "original": "Original",
      "language": "Limbă",
      "translation": "Traducere"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Abonare eșuată!",
      "title": "Abonare eșuată!",
      "subtitle": "A apărut o eroare la procesarea abonamentului.",
      "home": "Înapoi la pagina principală",
      "generic": "A apărut o eroare necunoscută din partea Linguise; contactați administratorul!"
    },
    "success": {
      "home": "Gestionați traducerile domeniului",
      "message": "Ne angajăm să vă oferim cea mai bună experiență de traducere. Echipa noastră de experți este disponibilă pentru orice întrebări sau asistență. Pentru început, faceți clic pe butonul de mai jos.",
      "subtitle": "Vă mulțumim că ați ales serviciul de traducere Linguise",
      "title": "Abonament activat!",
      "tab_title": "Vă mulțumim pentru abonare!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Abonament activat!",
      "title": "Abonament activat!",
      "subtitle": "Vă mulțumim că ați ales serviciul de traducere Linguise",
      "message": "Ne angajăm să vă oferim cea mai bună experiență de traducere. Echipa noastră de experți este disponibilă pentru orice întrebări sau asistență. Pentru început, faceți clic pe butonul de mai jos.",
      "home": "Gestionați traducerile domeniului"
    },
    "edit": {
      "title": "Gestionați abonamentul"
    },
    "list": {
      "title": "Lista abonamentelor",
      "description": "Lista abonamentelor domeniului dvs."
    },
    "table": {
      "domain": "Domeniu",
      "plan": "Plan",
      "status": "Status",
      "card": "Card",
      "usage": "Utilizare",
      "actions": "Acțiuni",
      "payment_method": "Modalitate de plată"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} cuvinte",
      "paidOffered": "{{words_used}} / {{words_allowed}} cuvinte\n(Inclusiv {{free_words}} cuvinte oferite)"
    },
    "popup": {
      "dueToday": "Total datorat astăzi",
      "nextPeriod": "Începând cu {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Alegeți un cont"
    }
  },
  "translation": {
    "main": {
      "parent": "Traduceri",
      "edit": "Editați traducerea"
    },
    "form": {
      "original": {
        "title": "Original în {{language}}"
      },
      "is_inline": "Această traducere este realizată din conținut în linie.",
      "inline_editor": {
        "count_warning": "Numărul zonelor inline nu corespunde cu originalul ({{current}} din {{expected}}).",
        "restore_original": "Restabilește textul original",
        "insert_placeholder": "Inserează un substituent",
        "drag": "Trage pentru a reordona zona",
        "area": "Zonă inline {{index}}",
        "restore": "Restabilește zonele inline lipsă"
      },
      "translation": {
        "title": "Traducere în {{language}}",
        "description": "Traducerea pe care doriți să o înlocuiți"
      }
    },
    "copy": {
      "title": "Copiază în traducerea manuală",
      "label": "Copiază în manuală"
    },
    "level": {
      "base": {
        "title": "Traducere de bază",
        "subtitle": "Automată · Traducere Linguise Cloud",
        "empty": "Nu există traducere de bază pentru acest text.",
        "overridden": "Alegerea ta este salvată, dar în locul ei este afișată cea mai recentă traducere îmbunătățită cu AI, deoarece „Suprascrie traducerile manuale și selectate” este pe Da în setările Traducerii AI. Dezactivează această setare pentru a folosi alegerea ta."
      },
      "not_generated": "Negenerată",
      "none": "Încă nimic",
      "ai": {
        "title": "Traducere îmbunătățită cu AI",
        "subtitle": "Automată · Linguise AI",
        "empty_title": "Încă negenerată pentru acest text",
        "empty_description": "Linguise AI oferă traduceri mai naturale, folosind contextul paginii și al site-ului tău. Pentru a obține una aici:",
        "empty_step_1": "Mergi la Traducere AI › Setări și setează Activează traducerea AI pe „Doar reguli”, „Doar editor live” sau „Reguli și editor live”.",
        "empty_step_2": "Aplic-o printr-o regulă care se potrivește cu această pagină sau activeaz-o pagină cu pagină din Editorul Live.",
        "empty_step_3": "Traducerea îmbunătățită cu AI va apărea aici după ce este generată. Folosește creditele tale AI.",
        "open_settings": "Deschide setările Traducerii AI",
        "open_editor": "Deschide Editorul Live",
        "overrides_selection": "Alegerea ta este salvată, dar în locul ei este afișată această traducere îmbunătățită cu AI, deoarece „Suprascrie traducerile manuale și selectate” este pe Da în setările Traducerii AI. Dezactivează această setare pentru a folosi alegerea ta.",
        "overrides_version": "Versiunea aleasă de tine este salvată, dar în locul ei este afișată cea mai recentă versiune îmbunătățită cu AI, deoarece „Suprascrie traducerile manuale și selectate” este pe Da în setările Traducerii AI. Dezactivează această setare pentru a folosi versiunea aleasă."
      },
      "manual": {
        "title": "Traducere manuală",
        "subtitle": "Scrisă de tine · are prioritate față de traducerile automate",
        "empty": "Goală",
        "saved_but_overridden": "Salvată ca alegere a ta, dar nu este afișată automat deoarece „Suprascrie traducerile manuale” este pe Da în setările Traducerii AI: traducerea îmbunătățită cu AI are prioritate până când această setare este dezactivată.",
        "ignored": "Nu este afișată automat deoarece „Suprascrie traducerile manuale” este pe Da în setările Traducerii AI. Selecteaz-o pentru a o folosi la acest text.",
        "label": "Traducerea ta",
        "placeholder": "Scrie propria traducere...",
        "last_updated": "Ultima editare: {{date}}",
        "save_hint": "Salvarea unei traduceri manuale o face activă.",
        "delete": "Șterge traducerea manuală",
        "delete_confirm": "Confirmă ștergerea traducerii manuale"
      }
    },
    "history": {
      "title": "Versiuni îmbunătățite cu AI",
      "subtitle": "Fiecare regenerare din Editorul Live este păstrată",
      "unknown_model": "Model necunoscut",
      "current": "Curentă",
      "restore": "Restaurează această versiune",
      "restore_note": "Prin restaurare, versiunea respectivă devine traducerea curentă îmbunătățită cu AI. Nu se șterge nimic.",
      "version_of": "Versiunea {{current}} din {{total}}",
      "hide": "Ascunde istoricul ({{total}})",
      "show": "Arată istoricul ({{total}})"
    },
    "choose": {
      "title": "Traduceri în {{language}} · alege-o pe cea văzută de vizitatori",
      "current": "Momentan pe site-ul tău:",
      "priority": "Prioritate implicită: Manuală › Îmbunătățită cu AI › De bază. Alegerea ta este salvată doar pentru această traducere.",
      "reset": "Revino la prioritatea implicită",
      "reset_title": "Uită alegerea ta pentru acest text și folosește din nou prioritatea implicită",
      "resetting": "Se resetează ..."
    }
  },
  "translations": {
    "title": "Gestionarea traducerilor",
    "description": "Afișați și editați toate traducerile site-ului; pentru traducere vizuală, folosiți Editorul Live",
    "filter_languages": "Filtrează după limbi...",
    "filter_original": "Filtrează textul în limba originală",
    "filter_translation": "Filtrează după text tradus",
    "table": {
      "original": "Original",
      "language": "Limbă",
      "action": "Acțiune",
      "base": "De bază",
      "ai": "Îmbunătățită cu AI",
      "manual": "Manuală"
    },
    "filter_exact": "Potrivire exactă",
    "badge": {
      "active": "Activă",
      "overrides_manual": "Suprascrie manuala"
    },
    "cell": {
      "none": "niciuna",
      "not_generated": "negenerată",
      "ignored": "Ignorată – regula AI câștigă"
    },
    "tabs": {
      "all": "Toate",
      "manual": "Cu manuală",
      "ai": "Cu AI îmbunătățită",
      "base": "Doar de bază"
    },
    "levels_hint": "Fiecare text are până la 3 niveluri — cel marcat Activă este cel pe care îl văd vizitatorii."
  },
  "url": {
    "main": {
      "parent": "URL-uri",
      "edit": "Editați traducerea URL"
    },
    "form": {
      "original": {
        "title": "Original în {{language}}"
      },
      "translation": {
        "title": "Traducere URL în {{language}}",
        "description": "URL-ul pe care doriți să-l înlocuiți",
        "placeholder": "Înlocuire traducere URL",
        "invalid_full": "Încercați să schimbați cu un format incorect; ar trebui să modificați doar slug-urile/numele căii pentru traducerea URL",
        "invalid": "URL/cale furnizată invalidă"
      }
    }
  },
  "urls": {
    "title": "Gestionarea URL-urilor",
    "description": "Afișați și editați toate conținuturile traduse ale URL-urilor site-ului (avansat; aveți grijă la erorile 404)",
    "filter_languages": "Filtrează după limbi...",
    "filter_original": "Filtrează textul în limba originală",
    "filter_translation": "Filtrează după text tradus",
    "table": {
      "original": "Original",
      "language": "Limbă",
      "url": "URL tradus",
      "action": "Acțiune",
      "edited": "Traducerea originală a fost editată"
    }
  }
}
